import config from '../config';
import authorize from '../Utils/authorize';
import Axios from './base';

export const GetAIThreads = () => Axios().get('AI/threads');
export const GetAIThread = (threadId) => Axios().get(`AI/threads/${threadId}`);
export const GetAIObservabilityRuns = () => Axios().get('AI/observability/runs');
export const GetAIObservabilityRun = (requestId) => Axios().get(`AI/observability/runs/${requestId}`);
export const GetAIObservabilityThreads = () => Axios().get('AI/observability/threads');

const parseEventBlock = (block) => {
    let event = 'message';
    const data = [];

    block.split('\n').forEach((line) => {
        if (line.startsWith('event:'))
            event = line.slice(6).trim();
        if (line.startsWith('data:'))
            data.push(line.slice(5).trim());
    });

    if (data.length === 0)
        return null;

    const rawData = data.join('\n');
    try {
        return { event, data: JSON.parse(rawData) };
    }
    catch {
        return { event, data: { content: rawData } };
    }
};

export const StreamAIQuestion = async (body, onEvent, signal) => {
    const apiBase = String(config.REACT_APP_API_URL || '').replace(/\/$/, '');
    const response = await fetch(`${apiBase}/api/AI/ask`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${authorize.getToken()}`,
            'Grant': authorize.getIdToken(),
            'Content-Type': 'application/json',
            'Accept': 'text/event-stream',
        },
        body: JSON.stringify(body),
        signal,
    });

    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.message || payload.detail || 'RevJet AI is unavailable');
    }
    if (!response.body)
        throw new Error('This browser cannot read the RevJet AI response stream');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
        const { done, value } = await reader.read();
        buffer += decoder.decode(value || new Uint8Array(), { stream: !done }).replace(/\r\n/g, '\n');

        let boundary = buffer.indexOf('\n\n');
        while (boundary >= 0) {
            const parsed = parseEventBlock(buffer.slice(0, boundary));
            buffer = buffer.slice(boundary + 2);
            if (parsed)
                onEvent(parsed.event, parsed.data);
            boundary = buffer.indexOf('\n\n');
        }

        if (done)
            break;
    }
};
